import epcCost from './epcCost';
import otherCosts from './otherCosts';
import budgetFees from './budgetFees';
import totals from './totals';
import { Project } from '~/types/project';
import getDisplayValueCosts from './getDisiplayValueCosts';

export default function budget(project: Project, projectCosts: any, permissions: any) {
  return {
    getDisplayValueCosts: getDisplayValueCosts(project, projectCosts),
    epcCost: epcCost(project, projectCosts, permissions),
    interconnection: otherCosts(project, 'interconnection', projectCosts),
    otherItc: otherCosts(project, 'otherItc', projectCosts),
    otherNonItc: otherCosts(project, 'otherNonItc', projectCosts),
    budgetFees: budgetFees(project, projectCosts, permissions),
    totals: totals(project, projectCosts, permissions)
  };
}